import { useEffect, useState } from 'react';

import { spaltenAnzahl } from '@/modules/kacheln/useKachelLayout';

/** Bildschirmspalten der Kachel-Raster; passt sich beim Drehen und Skalieren an. */
export function useSpalten(): 1 | 2 | 3 {
  const [n, setN] = useState(() => (typeof window === 'undefined' ? 3 : spaltenAnzahl(window.innerWidth)));
  useEffect(() => {
    const f = () => setN(spaltenAnzahl(window.innerWidth));
    window.addEventListener('resize', f);
    return () => window.removeEventListener('resize', f);
  }, []);
  return n;
}
